import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@patternfly/react-core/dist/dynamic/layouts/Grid';
import { GridItem } from '@patternfly/react-core/dist/dynamic/layouts/Grid';
import { Card } from '@patternfly/react-core/dist/dynamic/components/Card';
import { CardBody } from '@patternfly/react-core/dist/dynamic/components/Card';
import { CardHeader } from '@patternfly/react-core/dist/dynamic/components/Card';
import { CardTitle } from '@patternfly/react-core/dist/dynamic/components/Card';

import Dashboard from '@console/shared/src/components/dashboard/Dashboard';
import { QueryBrowser } from '@console/shared/src/components/query-browser';
import {
  ResourceUtilizationQuery,
  useResourceMetricsQueries,
} from '@console/shared/src/promql/resource-metrics';
import { K8sResourceKind } from '@console/internal/module/k8s';

const ResourceMetricsDashboardCard: FC<ResourceMetricsDashboardCardProps> = (props) => (
  <Card className="resource-metrics-dashboard__card">
    <CardHeader>
      <CardTitle>{props.title}</CardTitle>
    </CardHeader>
    <CardBody className="resource-metrics-dashboard__card-body">
      <QueryBrowser queries={props.queries} namespace={props.namespace} disableZoom hideControls />
    </CardBody>
  </Card>
);

export const ResourceMetricsDashboard: FC<ResourceMetricsDashboardProps> = ({ obj }) => {
  const { t } = useTranslation();
  const queries = useResourceMetricsQueries(obj);
  return queries ? (
    <Dashboard className="resource-metrics-dashboard">
      <Grid hasGutter>
        <GridItem xl={6} lg={12}>
          <ResourceMetricsDashboardCard
            namespace={obj.metadata.namespace}
            queries={queries[ResourceUtilizationQuery.MEMORY]}
            title={t('public~Memory usage')}
          />
        </GridItem>
        <GridItem xl={6} lg={12}>
          <ResourceMetricsDashboardCard
            namespace={obj.metadata.namespace}
            queries={queries[ResourceUtilizationQuery.CPU]}
            title={t('public~CPU usage')}
          />
        </GridItem>
        <GridItem xl={6} lg={12}>
          <ResourceMetricsDashboardCard
            namespace={obj.metadata.namespace}
            queries={queries[ResourceUtilizationQuery.FILESYSTEM]}
            title={t('public~Filesystem')}
          />
        </GridItem>
        <GridItem xl={6} lg={12}>
          <ResourceMetricsDashboardCard
            namespace={obj.metadata.namespace}
            queries={queries[ResourceUtilizationQuery.NETWORK_IN]}
            title={t('public~Network in')}
          />
        </GridItem>
        <GridItem xl={6} lg={12}>
          <ResourceMetricsDashboardCard
            namespace={obj.metadata.namespace}
            queries={queries[ResourceUtilizationQuery.NETWORK_OUT]}
            title={t('public~Network out')}
          />
        </GridItem>
      </Grid>
    </Dashboard>
  ) : null;
};

type ResourceMetricsDashboardCardProps = {
  namespace?: string;
  title: string;
  queries: string[];
};

type ResourceMetricsDashboardProps = {
  obj: K8sResourceKind;
};
